<!-- <mat-form-field class="full-width margin padding">
  <textarea matInput placeholder="input startegy logic" id="area" [(ngModel)]="textInput"></textarea>

  <button (click)="submit()">Toggle</button>

</mat-form-field>

<div id="result"></div> -->


<div class="text-mode-container padding position-relative">
  <img src="./assets/images/text-mode.png" class="wall-img" />

  <div class="display-flex chamfer">


    <div class="display-flex-column text-area">
      <div class="note padding font-small text-negative text-center">
        <i>Note: Please input the logic in the format specified.<br />{{helpText}}</i>
      </div>
      <div class="pad-8 padding-hr">
        <mwl-text-input-autocomplete-container>
          <mat-form-field class="full-width condensed-form-field" color="accent" appearance="outline">
            <mat-label>Type your logic here (Press @ for suggestions)</mat-label>
            <textarea matInput class="form-control"
              [placeholder]="helpText"
              [(ngModel)]="formControlValue" mwlTextInputAutocomplete [findChoices]="findChoices"
              [autoCompleteArray]="autoCompleteArray" [showOptions]="showAutoCompleteOptions"
              [getChoiceLabel]="getChoiceLabel"
              (choiceSelected)="selectedOption($event)" (input)="inputEventHandler($event)">
            </textarea>
            <!-- <mat-icon matSuffix color="accent" class="pad-8 flex-centered-container font-larger cursor-pointer"
              (click)="micClicked()">keyboard_voice</mat-icon> -->

          </mat-form-field>
        </mwl-text-input-autocomplete-container>
      </div>
    </div>


  </div>

  <button mat-flat-button color="accent" *ngIf="!isEditing" class="margin-8-hr position-absolute centered"
    (click)="extractData()">Save and
    Proceed
  </button>

  <button mat-flat-button color="accent" *ngIf="isEditing" class="margin-8-hr position-absolute centered"
    (click)="extractData()">Update
  </button>


</div>
